module.exports = __webpack_public_path__ + "static/media/icon-leed.7389bc7a.svg";